import axios from "axios";
import { getAuthToken } from "../../../utils/getAuthToken";

const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || "http://localhost:8000";
// Calling has its own dedicated single-instance service — /api/calling/* routes
// there, everything else (teammembers, teams) stays on the main API server.
const CALLING_DOMAIN = process.env.REACT_APP_CALLING_URL || SERVER_DOMAIN;
const domainFor = (path) => (path.startsWith("/api/calling") ? CALLING_DOMAIN : SERVER_DOMAIN);

export async function authGet(path, params) {
  const token = await getAuthToken();
  const res = await axios.get(`${domainFor(path)}${path}`, { headers: { Authorization: `Bearer ${token}` }, params });
  return res.data;
}

export async function authSend(method, path, body) {
  const token = await getAuthToken();
  const res = await axios({
    method,
    url: `${domainFor(path)}${path}`,
    data: body,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  return res.data;
}

// Mirrors RING_BUDGET_MS in calling-server/modules/calling/calling.constants.js — the time a
// staged strategy has to walk through agents before Meta's own ~30-60s ring window closes.
export const RING_BUDGET_SECONDS = 45;

export const STRATEGIES = [
  {
    value: "simultaneous",
    title: "Ring everyone",
    description: "Every agent's phone rings at once. Whoever answers first takes the call.",
  },
  {
    value: "sequential",
    title: "Ring in order",
    description: "One agent at a time, top to bottom. If they don't pick up, it moves to the next.",
  },
  {
    value: "smart",
    title: "Smart distribution",
    description: "Rings only agents who are free, longest without a call first. Never interrupts someone already on a call.",
    recommended: true,
  },
];

export const DEFAULT_ROUTING = {
  mode: "all_online",
  activeRingGroupId: "",
  strategy: "simultaneous",
  ringSecondsPerAgent: 15,
  skipBusyAgents: true,
  whenNobodyAnswers: "ring_everyone",
};

/** Server shape -> editable draft (ids as strings, nulls as ""). */
export function toDraft(routing) {
  return {
    ...DEFAULT_ROUTING,
    ...routing,
    activeRingGroupId: routing?.activeRingGroupId ? String(routing.activeRingGroupId) : "",
  };
}

export const isDirty = (a, b) => JSON.stringify(a) !== JSON.stringify(b);
